// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3R8kF","title":"AfterBackImages_title__29H1n","images":"AfterBackImages_images__3Iqvk"};